<template>
  <div class="contents">
    <div class="content_map">
      <MachineryNav></MachineryNav>
      <div class="tablist_item">
        <div
          class="items"
          :class="[{ active: activeName == item.name }]"
          v-for="item in itemList"
          :key="item.id"
          @click="tabItemClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import MachineryNav from "./MachineryNav.vue";
export default {
  components: {
    MachineryNav
  },
  data() {
    return {
      activeName: "减排机具时间分布",
      itemList: [
        {
          id: 1,
          name: "减排机具时间分布"
        },
        {
          id: 2,
          name: "减排机具地区分布"
        }
      ],
      machineShow: true,
      mapShow: false,
      areasuperShow: false,
      operationShow: false
    };
  },
  mounted() {
    if (window.location.pathname === "/view/MachineTar") {
      this.activeName = "减排机具时间分布";
      this.$router.push("/TimeDistribution");
    } else if (window.location.pathname === "/view/ToolDistribution") {
      this.activeName = "减排机具地区分布";
      this.$router.push("/ToolDistribution");
    }
  },
  methods: {
    tabItemClick(item) {
      this.activeName = item.name;
      if (item.id === 1) {
        this.$router.push("/TimeDistribution");
      } else if (item.id === 2) {
        this.$router.push("/ToolDistribution");
      }
    }
  }
};
</script>
<style scoped>
.contents {
  width: 100%;
  height: 100%;
  /* margin: 0 auto; */
}

.content_map {
  width: 100%;
  margin: 0 auto;
}
.tablist_item {
  display: flex;
  margin-bottom: 1vh;
  margin-top: 1vh;
}
.items {
  height: 3.5vh;
  padding: 0 1vw;
  background-color: #0048c2;
  color: #ffffff;
  font-size: 0.8vw;
  text-align: center;
  line-height: 3.5vh;
  margin-right: 10px;
  border-radius: 0.2vw;
  cursor: pointer;
}
.items.active {
  height: 3.5vh;
  background-color: #f4f4f4;
  color: #000;
  font-size: 0.8vw;
  text-align: center;
  line-height: 3.5vh;
  border-radius: 0.2vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineTar.vue